import React, { useState, useEffect } from 'react';
import {
  Grid,
  Menu,
  MenuItem,
  TextField,
  Typography,
  InputLabel,
  Box,
  Button,
  Card,
  Select,
  Icon,
  Input,
  Link,
  accordionDetailsClasses,
} from '@mui/material';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "trainerRoutes";
import editRoutes from "trainerEditRoutes";
import Container from "@mui/material/Container";
import bgImage from "assets/images/OIG1.jpg";
import MKBox from "components/MKBox";
import CountryList from 'country-list-with-dial-code-and-flag';
import Logo from "assets/images/skill2.png";
import CompanyIcon from "assets/images/companyicon.png";
import Expectation from "assets/images/team_3082743.png";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MKButton from "components/MKButton";
import { LocationOn, AttachMoney } from '@mui/icons-material';
import MKTypography from "components/MKTypography";
import SimpleFooter from "examples/Footers/SimpleFooter";
import { useNavigate } from 'react-router-dom';
import { getAllISOCodes, getAllInfoByISO } from 'iso-country-currency';
import FormControl from '@mui/material/FormControl';
import Modal from "@mui/material/Modal";
import DatePicker from "react-multi-date-picker";
import Breadcrumbs from "examples/Breadcrumbs";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import MKAlert from "components/MKAlert";
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import AWS from 'aws-sdk';
import '../../../styles.css';
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";


const Page = () => {
  // const styles = {
  //   gridItem: {
  //     border: '1px double #ccc',
  //     borderRadius: '30px',
  //     padding: '16px',
  //     marginBottom: '16px',
  //     boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
  //     width: '500px',
  //     backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 1.0), backdropFilter: "saturate(200%) blur(30px)", boxShadow: ({ boxShadows: { xxl } }) => xxl,
  //   },
  //   trainingInfo: {
  //     display: 'flex',
  //     flexDirection: 'column',
  //   },
  //   trainingName: {
  //     // marginTop: '10px',
  //     marginBottom: '8px',
  //     fontSize: 'medium',
  //     color: 'rgb(60, 150, 190)',
  //   },
  //   gridContent: {
  //     padding: '8px',
  //   },
  // };
  const [trainerProfileCreate, setTrainerProfileCreate] = useState(false);
  const [trainerWithPayment, setTrainerWithPayment] = useState(false);
  const [trainerWithPayment20, setTrainerWithPayment20] = useState(false);
  const [trainerWith2, setTrainerWith2] = useState(false);
  const [trainerWith5, setTrainerWith5] = useState(false);
  const [trainerWith8, setTrainerWith8] = useState(false);
  const [trainerWithPaymentStatus, setTrainerWithPaymentStatus] = useState([]);
  const [trainerWithPaymentStatus20, setTrainerWithPaymentStatus20] = useState([]);
  const [trainerWithStatus2, setTrainerWithStatus2] = useState([]);
  const [trainerWithStatus5, setTrainerWithStatus5] = useState([]);
  const [trainerWithStatus8, setTrainerWithStatus8] = useState([]);
  const [appliedTrainingDetails, setAppliedTrainingDetails] = useState([]);

  const handleAppliedScroll = (direction) => {
    const container = document.getElementById('applied-training-list-container');
    const scrollAmount = direction === 'left' ? -600 : 600;
    container.scrollBy({
      left: scrollAmount,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    const container = document.getElementById('applied-training-list-container');
    if (container) {
      container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          handleAppliedScroll('left');
        } else if (e.key === 'ArrowRight') {
          handleAppliedScroll('right');
        }
      });
    }
  }, []);

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log("iddddddddddddd", id);
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerprofileuidexists/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.exists === false) {
          // setSubmitOTPCompleted(false);
          setTrainerProfileCreate(true);
          window.location.href = "/app/trainerprofile";
        } else {
          console.log("hiiiiiiiiiiiiii", data.exists);
          setTrainerProfileCreate(false);
          // window.location.reload();
        }
      })
      .catch(error => {
        // Handle any errors that occurred during the fetch
        console.error("Error fetching data:", error);
      });
  }, [localStorage.getItem("userId")]);
  console.log("trainerProfileCreate", trainerProfileCreate);

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "nocard";
    let filterStatus = "nofilter";
    fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-applied-training/${id}/${filterStatus}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setAppliedTrainingDetails(data);

          // Clear previous data
          setTrainerWithStatus2([]);
          setTrainerWithStatus5([]);
          setTrainerWithStatus8([]);
          setTrainerWithPaymentStatus([]);
          setTrainerWithPaymentStatus20([]);

          data.forEach((trainer) => {
            const status = parseInt(trainer.applyTrainingStatus);

            if (status === 2) {
              console.log("1");
              setTrainerWith2(true);
              setTrainerWithStatus2((prev) => [...prev, trainer]);
            } else if (status === 5) {
              console.log("2");
              setTrainerWith5(true);
              setTrainerWithStatus5((prev) => [...prev, trainer]);
            } else if (status === 8) {
              console.log("3");
              setTrainerWith8(true);
              setTrainerWithStatus8((prev) => [...prev, trainer]);
            } else if (status === 10) {
              console.log("4");
              setTrainerWithPayment(true);
              setTrainerWithPaymentStatus((prev) => [...prev, trainer]);
            } else if (status === 20) {
              console.log("5");
              setTrainerWithPayment20(true);
              setTrainerWithPaymentStatus20((prev) => [...prev, trainer]);
            }
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("userId")]);
  console.log("appliedTrainingDetails", appliedTrainingDetails);
  console.log("trainerWithPayment", trainerWithPayment);
  console.log("trainerWithPaymentStatus", trainerWithPaymentStatus);
  console.log("trainerWithPayment20", trainerWithPayment20);
  console.log("trainerWithPaymentStatus20", trainerWithPaymentStatus20);

  console.log("trainerWithStatus2", trainerWithStatus2);
  console.log("trainerWithStatus5", trainerWithStatus5);
  console.log("trainerWithStatus8", trainerWithStatus8);

  const [appliedTrainings, setAppliedTrainings] = useState([]);
  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "nocard";
    let filterStatus = "appliedTrainings";
    fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-applied-training/${id}/${filterStatus}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setAppliedTrainings(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("userId"), appliedTrainingDetails]);
  console.log("appliedTrainings", appliedTrainings);

  const [acceptedTrainings, setAcceptedTrainings] = useState([]);
  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "nocard";
    let filterStatus = "acceptedTrainings";
    fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-applied-training/${id}/${filterStatus}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setAcceptedTrainings(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("userId"), appliedTrainingDetails]);
  console.log("acceptedTrainings", acceptedTrainings);

  const [vanquishedTrainings, setVanquishedTrainings] = useState([]);
  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "nocard";
    let filterStatus = "vanquishedTrainings";
    fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-applied-training/${id}/${filterStatus}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setVanquishedTrainings(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("userId"), appliedTrainingDetails]);
  console.log("vanquishedTrainings", vanquishedTrainings);

  const [completedTrainings, setCompletedTrainings] = useState([]);
  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "nocard";
    let filterStatus = "completedTrainings";
    fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-applied-training/${id}/${filterStatus}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setCompletedTrainings(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("userId"), appliedTrainingDetails]);
  console.log("completedTrainings", completedTrainings);

  function getStatusMessage(training) {
    console.log("training.applyTrainingStatus", training.applyTrainingStatus);
    if (training.applyTrainingStatus === "1") {
      return "Awaiting For Training Partner's response";
    } else if (training.applyTrainingStatus === "2") {
      return "Training Partner - Accepted. Awaiting for your response";
    } else if (training.applyTrainingStatus === "13") {
      return "Training Partner has Declined your request";
    } else if (training.applyTrainingStatus === "3") {
      return "Mutually agreed for the training";
    } else if (training.applyTrainingStatus === "14") {
      return "Trainer Declined the training";
    } else if (training.applyTrainingStatus === "4") {
      return "Discussion on-going with Training Partner";
    } else if (training.applyTrainingStatus === "5") {
      return "Training Scheduled - Awaiting for your Confirmation";
    } else if (training.applyTrainingStatus === "6") {
      return "Training Scheduling confirmed with Training Partner";
    } else if (training.applyTrainingStatus === "7") {
      return "Training has been Started";
    } else if (training.applyTrainingStatus === "8") {
      return "Training has been Completed";
    } else if (training.applyTrainingStatus === "9") {
      return "Invoice sent to the Training Partner";
    } else if (training.applyTrainingStatus === "10") {
      return "Payment Completed by the Training Partner";
    } else if (training.applyTrainingStatus === "11") {
      return "Training Completed and Payment Received";
    } else if (training.applyTrainingStatus === "12") {
      return "Payment not Received by the Trainer";
    } else if (training.applyTrainingStatus === "16") {
      return "Your training request is on-hold by Training Partner";
    } else if (training.applyTrainingStatus === "17") {
      return "1st New Payment Date given by Training Partner";
    } else if (training.applyTrainingStatus === "18") {
      return "2nd New Payment Date given by Training Partner";
    } else if (training.applyTrainingStatus === "19") {
      return "Final New Payment Date given by Training Partner";
    } else if (training.applyTrainingStatus === "20") {
      return "Final Completed by the Training Partner";
    } else {
      return "Unknown Status";
    }
  }
  const navigate = useNavigate();

  const onAppliedMoreDetailsClick = (training) => {
    console.log("training", training.appliedTrainingID);
    navigate(`/app/appliedtrainingmoredetails/${training.appliedTrainingID}/`);
  };

  const renderTrainerCards = (trainers, onClickHandler) => {
    return trainers.map((training, index) => (
      <Grid item xs={6} key={training.id}>
        <div className="gridItemSeeMore">
          <div className="gridContentSeeMore">
            <div className="trainingInfo">
              <Typography variant="subtitle1" className="trainingNameSeeMore" ><strong>{training.trainingName}</strong></Typography>
              <Typography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.technology}
                </span>
              </Typography>
              <Typography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />{training.trainingCompanyName}
                </span>
              </Typography>
              <Typography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <LocationOn style={{ marginRight: '5px' }} /> {training.trainingMode}
                  {training.trainingMode === 'Classroom' ? ` | ${training.trainingLocations}` : ''}
                </span>
              </Typography>
              <Typography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  {training.currency}&nbsp;{training.totalTrainingBudget} |&nbsp;<img src={Expectation} alt="Expectation Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.trainingExpectation}
                </span>
              </Typography>
              <Typography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <CalendarMonthIcon style={{ marginRight: '5px' }} /> {training.expectedStartDate}
                </span>
              </Typography>
              <Typography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                  <strong> Status: {getStatusMessage(training)} </strong>
                </span>
              </Typography>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
              <Typography style={{ fontSize: 'medium' }}>
                Click on Respond button to Complete your action&nbsp;&nbsp;
              </Typography>
              <MKButton variant="gradient" color="info" size="small" onClick={() => onClickHandler(training)} style={{ padding: '5px 10px' }}>Respond</MKButton>
            </div>
          </div>
        </div>
      </Grid>
    ));
  };

  return (
    <>
      <IdleTimeOutHandler />
      <DefaultNavbar
        routes={trainerProfileCreate ? routes : editRoutes}
        sticky
      />
      <Card
        sx={{
          minHeight: '101vh',
          height: 'auto',
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <Grid container>
            <Grid item xs={12} style={{ marginTop: "150px" }}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                  <Grid item xs={12} style={{ display: 'flex' }}>
                    <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                      <span style={{ color: 'black' }}>Pending</span>{' '}
                      <span style={{ color: '#2e1114' }}>Actions</span>
                    </MKTypography>
                  </Grid>
                </Grid>

                {trainerWithStatus2.length === 0 && trainerWithStatus5.length === 0 && trainerWithStatus8.length === 0 ? (
                  <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>There are no pending actions</span>
                ) : (
                  ""
                )}

                {trainerWithStatus2.length === 0 ? (
                  ""
                ) : (
                  <Grid container spacing={2}>
                    {renderTrainerCards(trainerWithStatus2, onAppliedMoreDetailsClick)}
                  </Grid>
                )}

                {trainerWithStatus5.length === 0 ? (
                  ""
                ) : (
                  <Grid container spacing={2}>
                    {renderTrainerCards(trainerWithStatus5, onAppliedMoreDetailsClick)}
                  </Grid>
                )}

                {trainerWithStatus8.length === 0 ? (
                  ""
                ) : (
                  <Grid container spacing={2}>
                    {renderTrainerCards(trainerWithStatus8, onAppliedMoreDetailsClick)}
                  </Grid>
                )}
              </div>
            </Grid>
          </Grid>
        </Container>
      </Card>
    </>
  );
};

export default Page;